export const getObjectElementByValuePath = function (obj, path, value) {
  if (obj === undefined) {
    return {};
  }
  const item = Object.fromEntries(
    Object.entries(obj).filter(([, val]) => {
      return objectByString(val, path) === value;
    })
  );

  return item[Object.keys(item)[0]];
};

export const getFilteredObjectByValuePath = function (obj, path, value) {
  if (obj === undefined) {
    return {};
  }
  return Object.fromEntries(
    Object.entries(obj).filter(([, val]) => {
      return String(objectByString(val, path)) === String(value);
    })
  );
};

export const getElementKeyByValuePath = function (obj, path, value) {
  if (obj === undefined) {
    return {};
  }

  const filtered = Object.entries(obj).filter(([, val]) => {
    return objectByString(val, path) === value;
  });

  return Number(filtered[0][0]);
};

export const objectByString = function (o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1");
  s = s.replace(/^\./, "");
  let a = s.split(".");
  for (let i = 0, n = a.length; i < n; ++i) {
    let k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
};

export const getLastItem = function (obj) {
  return obj[Object.keys(obj).pop()];
};
